/**
 * @module JQM
 * @param  {Object} $ jQuery-Objekt
 * @return {Null}
 */
(function($) {
    "use strict";

    /**
     * Global bereit gestelltes Objekt, das durch Module erweitert werden
     * kann und welches die Grundfunktionalität der Anwendung bereit stellt.
     *
     * @class  JQM
     * @constructor
     */
    var JQM = (function() {
        /**
         * Initialisierung der Anwendung.
         *
         * @method init
         * @return {Null}
         */
        function init() {
            AOS.init();

            // Active-State auf mobilen Devices nutzen
            if("ontouchstart" in document.documentElement) {
                document.addEventListener("touchstart", function() {}, true);

                // only for mobile devices to prevent showing only a white screen when reloading the page
                $(window).on("load", function() {
                    AOS.refresh();
                });
            }

            // Initialisierung von JQM Modulen
            initModules();

            // Inject Elfsight ... pretty static
            if ($('#anchor-113')) {
                $("#anchor-113 div.container:first-child > div.row:first-child > div:first-child > div:first-child").append('<script src="https://static.elfsight.com/platform/platform.js" data-use-service-core defer></script><div class="elfsight-app-64adc3ac-c69a-4f09-ad9d-8ae58e984c6f" data-elfsight-app-lazy></div>');
            }
        }

        /**
         * Es werden alle Module initialisiert, die über die Funktion `init`
         * verfügen. Um eine Initialisierung zu verhindern, wird bei den entsprechenden
         * Modulen für die Init-Funktion `_init` verwendet.
         *
         * @private
         * @method initModules
         * @return {Null}
         */
        function initModules() {
            var module;
            for(module in JQM) {
                if(
                    JQM.hasOwnProperty(module) &&
                    typeof JQM[module].init === "function"
                ) {
                    JQM[module].init();
                }
            }
        }

        return {
            init: init
        };
    })();

    $(document).ready(function() {
        JQM.init();
    });

    // Im globalen Kontext bereitstellen
    window.JQM = JQM;
})(jQuery);
